export default __webpack_public_path__ + "static/media/joker.8c1712f5.svg";